var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxLinearGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.889,
    height: 16.889,
    viewBox: "0 0 16.889 16.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_gallery",
    "data-name": "vuesax/linear/gallery",
    transform: "translate(-364 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery",
    transform: "translate(364 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.926,14.074H9.148c3.518,0,4.926-1.407,4.926-4.926V4.926C14.074,1.407,12.667,0,9.148,0H4.926C1.407,0,0,1.407,0,4.926V9.148C0,12.667,1.407,14.074,4.926,14.074Z",
    transform: "translate(1.407 1.407)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.815,1.407A1.407,1.407,0,1,1,1.407,0,1.407,1.407,0,0,1,2.815,1.407Z",
    transform: "translate(4.926 4.222)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,4.892,3.469,2.563a1.585,1.585,0,0,1,1.858.1l.232.2a1.569,1.569,0,0,0,1.984,0L10.471.354a1.569,1.569,0,0,1,1.984,0l1.147.985",
    transform: "translate(1.879 8.443)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H16.889V16.889H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxLinearGallery);
export default __webpack_public_path__ + "static/media/vuesax-linear-gallery.9f2f68e88d6e36a4f0abcc4ee9511ce6.svg";
export { ForwardRef as ReactComponent };